import { Client } from './../../dto/client/client';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { finalize, Subscription } from 'rxjs';
import { MatSort, Sort } from '@angular/material/sort';
import { SpinnerService } from '../../service/spinner.service';
import { HttpPaginatedDataSource } from '../../utils/HttpPaginatedDataSource';
import { ClientService } from '../../service/client.service';
import { AlertController, ToastController } from '@ionic/angular';;
import { TranslateService } from '@ngx-translate/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';


@Component({
  selector: 'app-client',
  templateUrl: './client.page.html',
  styleUrls: ['./client.page.scss']
})
export class ClientPage implements OnInit, OnDestroy {
  FilterForm: FormGroup;
  public data: HttpPaginatedDataSource<any>;
  public pageIndex = 1;

  public pageSize: number;
  public pageSizeOpts: number[];
  private unsubscribe: Subscription[] = [];
  csv_file: any = null;
  upload_success = false;
  downloadTemplateUrl = '';
  importShown: Boolean = false;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public columnsToDisplay = ['name', 'client_id', 'barcode_prefix', 'Sector', 'Edit'];

  public sortCol = "creation_date";
  public sortDir = "desc";

  constructor(private toastController: ToastController, public alertController: AlertController, private formBuilder: FormBuilder, private spinnerService: SpinnerService,
    public router: Router, private clientService: ClientService, private translateService: TranslateService) { }

  async presentAlertConfirm(client) {
    let message = this.translateService.instant("Do you really want to delete that client:") + `<strong>${client.name}</strong> ?`;
    let header = this.translateService.instant("Delete client");
    let yes = this.translateService.instant("Yes");
    let no = this.translateService.instant("No");

    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: no,
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: yes,
          id: 'confirm-button',
          handler: () => {
            this.clientService.deleteById(client.id).pipe(finalize(() => {
            })).subscribe(async val => {
              const toast = await this.toastController.create({
                message: this.translateService.instant('Delete successfully'),
                duration: 2000
              });
              toast.present()
              this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
            });
          }
        }
      ]
    });

    await alert.present();
  }

  ngOnInit() {
    this.data = new HttpPaginatedDataSource([]);
    this.data.sort = this.sort;
    this.data.paginator = this.paginator;
    this.pageSizeOpts = [5, 10, 15, 20, 100]
    this.pageSize = 15;
    this.pageIndex = 0;
    this.csv_file = null;
    this.upload_success = false;
    this.FilterForm = this.formBuilder.group({
      name: [''],
      barcode_prefix: [''],
      sector: ['']
    });

    this.unsubscribe.push(this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url === '/admin/client') {
        this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
      }
    }));

    this.sort.sortChange.subscribe((sort: Sort) => {
      this.paginator.pageIndex = 0;
      this.pageIndex = 0;
      this.sortCol = sort.active;
      if (this.sortCol === "Sector")
        this.sortCol = "sector";
      this.sortDir = sort.direction;
      this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
    });

  }

  get f() { return this.FilterForm.controls; }

  private CreateDataFilter(): Client {
    const data = new Client();
    data.name__icontains = this.f.name.value
    data.barcode_prefix__icontains = this.f.barcode_prefix.value
    data.sector__icontains = this.f.sector.value
    return data;
  }

  filterForm() {
    this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
  }

  onSubmit(pageSize: number, pageIndex: number, dataFilter: Client, sortCol: string, sortDir: string) {
    this.spinnerService.show();

    this.unsubscribe.push(
      this.clientService.getAdmin(pageSize, pageIndex, dataFilter, sortCol, sortDir).pipe(finalize(() => {
        this.spinnerService.hide();
      })).subscribe(val => {
        this.data.data = val.data;
        this.data.sort = this.sort;
        this.data._updatePaginator(val.total)
      })
    );
  }


  change(pageEvent: PageEvent) {
    if (this.pageIndex !== pageEvent.pageIndex || this.pageSize !== pageEvent.pageSize) {
      this.pageIndex = pageEvent.pageIndex;
      this.pageSize = pageEvent.pageSize;
      this.data = new HttpPaginatedDataSource([]);
      this.onSubmit(this.pageSize, this.pageIndex, this.CreateDataFilter(), this.sortCol, this.sortDir);
    }
  }



  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }

  public goTo(path) {
    this.router.navigate([path])
  }
  onChange(event: any) {
    this.csv_file = event.target.files[0];

  }

 uploadCsvFile() {
    this.clientService.uploadClientsCsv(this.csv_file).subscribe(
      res => {
        console.log(res);
        if (res == 201) {
          this.upload_success = true;

        }
       this.router.navigate(['admin/client'])
      }
    );
  }
  getResponseFile() {
    return this.clientService.downloadResponseFile().subscribe(
      (res: any) => {
        console.log(res);
        const link = document.createElement('a');

         if (link.download !== undefined) {
        const url = URL.createObjectURL(res);
        link.setAttribute('href', url);
        link.setAttribute('download', 'last_uploaded_file.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }  });

  }

  async getTemplate() {
    return this.clientService.downloadTemplate().subscribe(
      (res: any) => {
        console.log(res);
        const link = document.createElement('a');

         if (link.download !== undefined) {
        const url = URL.createObjectURL(res);
        link.setAttribute('href', url);
        link.setAttribute('download', 'template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }  });
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  async addnew() {
    this.router.navigate(['/admin/newclient']);
  }

  async editClient(id_client: string) {
    this.router.navigate(['/admin/editclient'], { queryParams: { idClient: id_client } })
  }
  showImport() {
    if (!this.importShown)
      this.importShown = true;
    else
      this.importShown = false;
  }
}
